import img from '../../assets/images/icon/404.png';
import {useNavigate} from 'react-router-dom';

import * as Styled from './style';

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <Styled.Card>
      <Styled.Img>
        <img src={img} alt='' width={390} height={298} />
      </Styled.Img>
      <Styled.Text variant='h6'>Такой страницы не существует :(</Styled.Text>
      <Styled.Button
        onClick={() => {
          navigate('/');
        }}
        variant='contained'
      >
        Вернуться назад
      </Styled.Button>
    </Styled.Card>
  );
};
export default NotFoundPage;